var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRemove(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 33,
    viewBox: "0 0 32 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    transform: "translate(0 0.5)",
    fill: "white",
    fillOpacity: 0.01
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.33333 9.83333H22.6667C23.0203 9.83333 23.3594 9.97381 23.6095 10.2239C23.8595 10.4739 24 10.813 24 11.1667C24 11.5203 23.8595 11.8594 23.6095 12.1095C23.3594 12.3595 23.0203 12.5 22.6667 12.5H9.33333C8.97971 12.5 8.64057 12.3595 8.39052 12.1095C8.14048 11.8594 8 11.5203 8 11.1667C8 10.813 8.14048 10.4739 8.39052 10.2239C8.64057 9.97381 8.97971 9.83333 9.33333 9.83333ZM13.04 24.5C12.7428 24.5 12.454 24.4007 12.2197 24.2178C11.9854 24.0349 11.8189 23.779 11.7467 23.4907L9.54133 14.66C9.51709 14.5619 9.51545 14.4597 9.53653 14.3609C9.5576 14.2621 9.60086 14.1694 9.66301 14.0898C9.72517 14.0101 9.8046 13.9457 9.89532 13.9013C9.98603 13.8568 10.0857 13.8336 10.1867 13.8333H21.8133C21.9146 13.8334 22.0145 13.8565 22.1055 13.9009C22.1965 13.9453 22.2762 14.0098 22.3386 14.0897C22.4009 14.1695 22.4442 14.2624 22.4653 14.3615C22.4863 14.4605 22.4845 14.5631 22.46 14.6613L20.252 23.4907C20.1798 23.779 20.0133 24.0349 19.7789 24.2178C19.5446 24.4007 19.2559 24.5 18.9587 24.5H13.0413H13.04ZM14.6667 8.5H17.3333C17.687 8.5 18.0261 8.64048 18.2761 8.89052C18.5262 9.14057 18.6667 9.47971 18.6667 9.83333H13.3333C13.3333 9.47971 13.4738 9.14057 13.7239 8.89052C13.9739 8.64048 14.313 8.5 14.6667 8.5Z",
    fill: "#D13D3E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRemove);
export default __webpack_public_path__ + "static/media/remove.0a9ed094a449ae322d8ec23da0f5933e.svg";
export { ForwardRef as ReactComponent };